import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";

export interface UiState {
  connectingWallet: boolean;
}

const initialState: UiState = {
  connectingWallet: false,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    connectWallet: (state) => {
      state.connectingWallet = true;
    },
    walletConnected: (state) => {
      state.connectingWallet = false;
    },
  },
});

export const { connectWallet, walletConnected } = uiSlice.actions;

export const selectConnectingWallet = (state: RootState): boolean =>
  state.ui.connectingWallet;

export default uiSlice.reducer;
